import React from 'react';
import { DateRangePickerWrapper, DateRangePickerWrapperProps } from './DateRangePickerWrapper';

export const DateRangePickerExporter: React.FunctionComponent<DateRangePickerWrapperProps> =
    function (props: DateRangePickerWrapperProps) {
        return <DateRangePickerWrapper {...props} />;
    };
